import { pb } from "@/lib/pocketbase";
import { pbRepository } from "./pocketbase-repository";
import { auth } from "./auth.service";
import type { NoteDocument, NoteKind } from "@/types/models";

const repo = pbRepository<NoteDocument>("note_documents");

/**
 * Mitschrift und Lernzettel teilen sich die Collection `note_documents`
 * (unterschieden per `kind`). Pro Thema existiert je Art genau ein Dokument,
 * das bei Bedarf lazy angelegt wird.
 */
export const notesService = {
  /** Lädt vorhandene Notizdokumente (ohne anzulegen) – für Vorschauen. */
  listByTopic(topicId: string): Promise<NoteDocument[]> {
    return repo.list({
      filter: pb.filter("topic = {:t}", { t: topicId }),
      perPage: 10,
    });
  },

  get(id: string): Promise<NoteDocument> {
    return repo.getOne(id);
  },

  async getOrCreate(topicId: string, kind: NoteKind): Promise<NoteDocument> {
    const items = await repo.list({
      filter: pb.filter("topic = {:t} && kind = {:k}", { t: topicId, k: kind }),
      perPage: 1,
    });
    if (items.length > 0) return items[0];

    return repo.create({
      owner: auth.currentUser()?.id,
      topic: topicId,
      kind,
      content: "",
    } as Partial<NoteDocument>);
  },

  save(id: string, content: string): Promise<NoteDocument> {
    return repo.update(id, { content });
  },
};
